import {HookManager} from "../../communication/HookManager";
import hookManagerInstance from "../../communication/HookManager";
import SkyClickPlayer from "../../components/custom/SkyClickPlayer";
import EventManager from "../../communication/EventManager";

class TechDecorator {

    /**
     * STATIC OBJECT - once object for all player instances
     */
    static hookManagerInstance:HookManager = hookManagerInstance;

    static readonly TECH_NAME:string;

    // Level 0: run static
    static bootingStaticApi() {}

    // Level 1: booting instance
    static bootingInstance(skyClickPlayer:SkyClickPlayer){
        return new this(skyClickPlayer);
    }

    /**
     * INSTANCE OBJECT - new object for each player instance
     */

    protected eventManager:EventManager;

    /**
     * Prepare decorator instance and provide information for other decorators.
     * Do not execute the tech decorator here. Use this.bootingExecution function to start the tech decorator
     * @param skyClickPlayer
     */
    constructor(protected skyClickPlayer:SkyClickPlayer){
        this.eventManager = skyClickPlayer.eventManager;
    }

    /**
     * Locate here the startup code for the decorated tech
     */
    public bootingExecution(){}


    /**
     * Return static tech name over instance object
     * @returns {string|any}
     */
    get techName(){
        return (<any>this).constructor.TECH_NAME;
    }

}

export default TechDecorator;


// WEBPACK FOOTER //
// ./src/app/tech/decorators/TechDecorator.ts